import React from 'react';
import { BuildPath } from  '@/helpers/Paths';
import { IReport } from  '@/interfaces/insightsp2';
import  '@/css/reports.scss';

const Reports = ({list}: {list:IReport[]}) => {

    return (
        <div className="reports">
            
            <p>Your organisation’s reports available for download</p>

            <ul>
                {list.map((report,idx) => {
                    return (
                        <li key={idx}>
                            <img src={`${BuildPath()}/images/insightsp2/DownloadStatsBtn.svg`} alt="" />
                            <a href={report.url}  aria-label='Download'>{report.name}</a>
                        </li>
                    )
                })}
            
            </ul>

        </div>
    );
};

export default Reports;